import React from 'react';
import { Box, Text, Button } from 'pcln-design-system';
import { ExternalLink } from 'pcln-icons';
import { QUALTRICS_URL } from '../../constants/misc';
/**
 * RequestFromType - Type of request from
 * @internal
 */
export var RequestFromType;
(function (RequestFromType) {
  RequestFromType["HOMEPAGE"] = "homePage";
  RequestFromType["POSTBOOKING"] = "travel-itinerary";
  RequestFromType["PENNYPORTAL"] = "pennyPortalPage";
})(RequestFromType || (RequestFromType = {}));
/**
 * Survey - Survey component
 * @internal
 */
const Survey = ({
  onClose,
  requestFrom
}) => {
  function handleOpen() {
    if (requestFrom === RequestFromType.HOMEPAGE) {
      window.open(`${QUALTRICS_URL}?Page=HP`, '_blank');
    } else if (requestFrom === RequestFromType.POSTBOOKING) {
      window.open(`${QUALTRICS_URL}?Page=PB`, '_blank');
    }
  }
  function handleClose() {
    onClose();
  }
  return React.createElement(Box, {
    p: 5,
    textAlign: 'center'
  }, React.createElement(Text, {
    fontWeight: 'bold',
    fontSize: 3,
    mb: 3
  }, "Help us Improve Penny!"), React.createElement(Text, {
    fontSize: 1
  }, "Give us 5 minutes and we'll give you", ' ', React.createElement(Text.span, {
    fontWeight: 'bold'
  }, "$10 off Hotel Express Deals*!")), React.createElement(Text, {
    fontSize: 1,
    mb: 2,
    mt: 1
  }, "(limited time offer)"), React.createElement(Text, {
    fontSize: 0,
    color: 'text.light',
    my: 3,
    fontWeight: 'normal'
  }, "*Minimum spend $100"), React.createElement(Box, null, React.createElement(Button, {
    variation: 'fill',
    width: 1,
    mb: 2,
    onClick: handleOpen
  }, "Let's Do It ", React.createElement(ExternalLink, {
    ml: 2
  })), React.createElement(Button, {
    variation: 'subtle',
    width: 1,
    onClick: handleClose
  }, "No Thanks")));
};
export default Survey;